import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import Logger from 'core/utils/Logger'

import { IEntityManagementSwitcherStateForSaving } from '../models'

export const savePlanIsRequired = async (
  globalPartnerId: string,
  data: IEntityManagementSwitcherStateForSaving[]
) => {
  const url = proxy(`/webservice/197/sp/v4/spJBPGlobalPartnersApplyChanges/call`)
  const payload = {
    'p.GlobalPartnerId': globalPartnerId,
    'p.Data': data,
  }

  const [accessToken] = getTokens()

  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  try {
    await Rest.post({
      url,
      payload,
      headers,
    })
  } catch (e) {
    Logger.error('savePlanIsRequired error')
  }
}
